// Compare the lhs and rhs (both lists of hyntax AST attributes) and populate
// the list of marked_areas with information about the differences between
// those attributes.
export default function compare_html_attribute_lists(lhs, rhs, marked_areas) {
  for( let i = 0; i < rhs.length; i += 1 ) {
    const match = find_attribute_matching(lhs, attribute_name(rhs[i]));
    if( match ) {
      if( rhs[i].value ) {
        if( match.value && match.value.content !== rhs[i].value.content ) {
          marked_areas.push({
            type: "changed",
            was: match.value.content,
            start: rhs[i].value.startPosition,
            end: rhs[i].value.endPosition,
          });
        } else if( !match.value && rhs[i].value ) {
          marked_areas.push({
            type: "missing",
            start: rhs[i].key.endPosition,
            end: rhs[i].value.endPosition,
          });
        }
      }
    } else {
      let end = rhs[i].key.endPosition;

      if( rhs[i].value ) {
        end = rhs[i].value.endPosition;
      }

      if( rhs[i].endWrapper ) {
        end = rhs[i].endWrapper.endPosition;
      }

      marked_areas.push({
        type: "missing",
        start: rhs[i].key.startPosition,
        end,
      });
    }
  }
}

// Given a hyntax AST for an attribute, return the name of the attribute.
function attribute_name(hyntax_attribute) {
  if( hyntax_attribute.key ) {
    return hyntax_attribute.key.content;
  }

  return null;
}

// Given a list of hyntax AST attributes, find the attribute with the given name.
function find_attribute_matching(lhs, name) {
  if( !lhs ) {
    return null;
  }

  for( let i = 0; i < lhs.length; i++ ) {
    const possible_name = attribute_name(lhs[i]);

    if( possible_name && possible_name === name ) {
      return lhs[i];
    }
  }

  return null;
}
